export enum Chain {
    APTOS = 'APTOS',
    ETHEREUM = 'ETHEREUM',
    POLYGON = 'POLYGON',
}

export enum OrderBook {
    BLUR = 'BLUR',
    LOOKS_RARE = 'LOOKS_RARE',
    OPENSEA = 'OPENSEA',
    RESERVOIR = 'RESERVOIR',
    X_2Y_2 = 'X_2Y_2',
}

export enum OrderKind {
    ALIENSWAP = 'ALIENSWAP',
    BLUR = 'BLUR',
    LOOKS_RARE_V2 = 'LOOKS_RARE_V2',
    OPENSEA = 'OPENSEA',
    SEAPORT = 'SEAPORT',
    SEAPORT_V14 = 'SEAPORT_V14',
    SEAPORT_V15 = 'SEAPORT_V15',
    X_2Y_2 = 'X_2Y_2',
    ZEROEX_V4 = 'ZEROEX_V4',
}

export enum OrderStatus {
    DONE = 'DONE',
    FAILED = 'FAILED',
    NEW = 'NEW',
    PENDING = 'PENDING',
}

export enum OrderType {
    LIMIT = 'LIMIT',
    LIMIT_MAKER = 'LIMIT_MAKER',
    MARKET = 'MARKET',
    STOP_LOSS = 'STOP_LOSS',
    STOP_LOSS_LIMIT = 'STOP_LOSS_LIMIT',
    TAKE_PROFIT = 'TAKE_PROFIT',
    TAKE_PROFIT_LIMIT = 'TAKE_PROFIT_LIMIT',
}

export enum Provider {
    RESERVOIR = 'RESERVOIR',
}

export enum RequestType {
    BUY = 'BUY',
    LIST = 'LIST',
    OFFER = 'OFFER',
    SELL = 'SELL',
}

export enum Side {
    BID = 'BID',
    ASK = 'ASK',
}

export const PREPARE_BUY = {
    type: OrderType.MARKET,
    side: Side.BID,
};

export const PREPARE_SELL = {
    type: OrderType.MARKET,
    side: Side.ASK,
};

export const PREPARE_OFFER = {
    type: OrderType.LIMIT,
    side: Side.BID,
};

export const PREPARE_LIST = {
    type: OrderType.LIMIT,
    side: Side.ASK,
};

export enum StepKind {
    TRANSACTION = 'transaction',
    SIGNATURE = 'signature',
}

export enum StepItemStatus {
    COMPLETE = 'complete',
    INCOMPLETE = 'incomplete',
}

export enum SignatureKind {
    EIP191 = 'eip191',
    EIP712 = 'eip712',
}
